import { TableRow, TableCell, Box } from '@mui/material'
import tableRowStyle from 'styles/tableRow.style'
import { ITableProps } from '../ITableProps'

export function NoRecordRowTableComponent<T>(props: ITableProps<T>) {
    const {
        headers,
        selectMode = true,
        hasCollapse,
        noDataText = 'No Data',
    } = props
    return (
        <TableRow role="checkbox" sx={tableRowStyle.root}>
            <TableCell
                colSpan={
                    headers.length +
                    (selectMode ? 1 : 0) +
                    (hasCollapse ? 1 : 0)
                }
                padding="checkbox"
            >
                <Box py={3} textAlign="center">
                    {noDataText}
                </Box>
            </TableCell>
        </TableRow>
    )
}
